module.exports = __webpack_public_path__ + "img/team-member-2.4dfa5e3d.png";